<div class="main"> 
    <p style="text-align: right;"><i class="fa fa-times" aria-hidden="true"></i></p>
  
<div class="content"> 
    <p class="text-p">Don't give students large hiring tests. They might lose interest.</p>
    <p class="use">Use</p>
    <p class="meetaide">Meetaide / calendly</p>
    <p class="lst-line">for a smooth interview scheduling process. Have a task list ready before you onboard an intern</p>
</div>
</div>